/**
 * Storage Constants
 *
 * 세션 스토리지 및 로컬 스토리지 키 상수
 */

/**
 * 마지막 설문 세션 토큰 저장 키
 * - 여러 페이지에서 공통으로 사용
 * - 사용자가 마지막으로 접근한 설문 세션을 추적
 */
export const LAST_SESSION_KEY = 'last_survey_session';
